import parseISO from '@teetsh/app/src/utils/time/parseISO';
import { LivretEval } from '@teetsh/app/src/containers/Livrets/types/livret';

export function deserialize(livretEval: any): LivretEval {
  return {
    ...livretEval,
    createdAt: parseISO(livretEval.createdAt),
    updatedAt: parseISO(livretEval.updatedAt),
  };
}
